import { Box, Card, Typography } from "@mui/material";
import DomainIcon from "@mui/icons-material/Domain";
import LandscapeIcon from "@mui/icons-material/Landscape";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import { enterpriseTokens } from "styles/theme";

const PortfolioStats = ({ builtUpArea, landArea, deliverArea }) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 0,
        p: 0,
        background: "transparent",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
          gap: 1,
          width: "100%",
        }}
      >
                {/* Land Area */}
        <Box
          sx={{
            p: 1.5,
            borderRadius: "3px",
            border: `1px solid ${enterpriseTokens.lineSoft}`,
            bgcolor: "#F8FAFC",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LandscapeIcon sx={{ fontSize: 18, color: enterpriseTokens.primary }} />
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: 500,
                color: enterpriseTokens.muted,
                fontFamily: "Inter, Outfit, sans-serif",
                textTransform: "uppercase",
              }}
            >
              Land Area
            </Typography>
          </Box>

          <Typography
            sx={{
              mt: 0.5,
              fontSize: "17px",
              fontWeight: 600,
              color: enterpriseTokens.navy,
              fontFamily: "Inter, Outfit, sans-serif",
            }}
          >
            {landArea} M sq.ft
          </Typography>
        </Box>
        {/* Built Up Area */}
        <Box
          sx={{
            p: 1.5,
            borderRadius: "3px",
            border: `1px solid ${enterpriseTokens.lineSoft}`,
            bgcolor: "#F8FAFC",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DomainIcon sx={{ fontSize: 18, color: enterpriseTokens.primary }} />
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: 500,
                color: enterpriseTokens.muted,
                fontFamily: "Inter, Outfit, sans-serif",
                textTransform: "uppercase",
              }}
            >
              Built-up Area
            </Typography>
          </Box>

          <Typography
            sx={{
              mt: 0.5,
              fontSize: "17px",
              fontWeight: 600,
              color: enterpriseTokens.navy,
              fontFamily: "Inter, Outfit, sans-serif",
            }}
          >
            {builtUpArea} M sq.ft
          </Typography>
        </Box>

        {/* AUM */}
        <Box
          sx={{
            p: 1.5,
            borderRadius: "3px",
            border: `1px solid ${enterpriseTokens.lineSoft}`,
            bgcolor: "#F8FAFC",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LocationCityIcon sx={{ fontSize: 18, color: enterpriseTokens.primary }} />
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: 500,
                color: enterpriseTokens.muted,
                fontFamily: "Inter, Outfit, sans-serif",
                textTransform: "uppercase",
              }}
            >
              Completion
            </Typography>
          </Box>

          <Typography
            sx={{
              mt: 0.5,
              fontSize: "17px",
              fontWeight: 600,
              color: enterpriseTokens.navy,
              fontFamily: "Inter, Outfit, sans-serif",
            }}
          >
            {deliverArea} M sq.ft
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default PortfolioStats;
